// extracted by mini-css-extract-plugin
module.exports = {"grid":"partnerGrid_grid__fGudu"};